import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import MarketingCard from './marketing-card';

const MarketingCards = ({ cards, layout }) => {
  const cardElements = useRef([]);
  useEffect(() => {
    const injectCards = () => {
      const container = document.getElementsByClassName('ss__results');
      const results = container[0];
      if (results) {
        const isDesktop = layout.bps.above.md.matches;
        const positions = isDesktop ? [6, 16, 24, 30] : [8, 16, 27, 31];
        const callbacks = [];
        results
          .querySelectorAll('.marketing-card')
          .forEach((element) => element.remove());
        results.childNodes.forEach((element, index) => {
          const cardIndex = positions.indexOf(index);
          if (cardIndex >= 0 && cards[cardIndex]) {
            callbacks.push(() => {
              results.insertBefore(
                cardElements.current[cardIndex].base.cloneNode(true),
                element,
              );
            });
          }
        });
        callbacks.forEach((callback) => callback());
      }
    };
    document.addEventListener('searchSpringDomReady', injectCards);
    return () => {
      document.removeEventListener('searchSpringDomReady', injectCards);
    };
  }, []);

  return (
    <div className="hidden marketingCards">
      {cards.map((item, index) => (
        <MarketingCard
          key={index}
          {...item}
          ref={(element) => {
            cardElements.current[index] = element;
          }}
        />
      ))}
    </div>
  );
};

export default MarketingCards;
